import { render, staticRenderFns } from "./Online-user.vue?vue&type=template&id=1da71742&"
import script from "./Online-user.vue?vue&type=script&lang=js&"
export * from "./Online-user.vue?vue&type=script&lang=js&"
import style0 from "./Online-user.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports